import _ from 'ext:lodash';
import moment from 'moment';
import Framework from 'framework';

export default class NewsItem {

	constructor(news) {
		this.id = news.id;
		this.title = news.title;
		this.excerpt = news.excerpt;
		this.startDate = news.startDate;
		this.endDate = news.endDate;
		this.newsDetailsPath = Framework.global.lt.club.clubPagePaths.newsDetails + '?id=' + news.id;
		this.disabled = news.disabled;
	}

	render() {
		if(this.title) {
			return `
				<a href="${this.newsDetailsPath}" id="news-${this.id}" class="card">
					<div class="card-block">
						<h3 class="card-title large m-b-sm">${this.title}</h3>
						<p class="m-b-1">${this.excerpt} <span class="card-link">Read more...</span></p>
						<p>${moment(this.startDate, moment.ISO_8601).fromNow()}</p>
					</div>
				</a>
			`;
		}else{
			return '';
		}
	}
}
